<template>
  <el-dialog title="批量操作" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">

      <!--名称-->
      <el-form-item label="选中数量" :label-width="formLabelWidth">
        <p class="red f20">{{ formData.ids.length || '暂无选中记录' }}</p>
      </el-form-item>

      <el-form-item label="所属分类：" :label-width="formLabelWidth">
        <el-select v-model="formData.category_id">
          <el-option label="不限" value=""></el-option>
          <el-option :label="item.name" :value="item.category_id" :key="item.category_id" v-for="item in category"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="虚拟阅读量" prop="virtual_views" :label-width="formLabelWidth">
        <el-input v-model="formData.virtual_views" placeholder="请输入" type="number" style="width:120px"></el-input>
      </el-form-item>

      <el-form-item label="排序" prop="article_sort" :label-width="formLabelWidth">
        <el-input v-model="formData.article_sort" placeholder="请输入" type="number" style="width:120px"></el-input>
        <span class="gray9">数字越小越靠前</span>
      </el-form-item>

      <el-form-item label="状态" prop="article_status" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.article_status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="删除" prop="is_delete" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.is_delete">
          <el-radio label="">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      
    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading || ids.length==0">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ArticleApi from '@/api/article.js';
export default {
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {
        ids: [],
        category_id: '',
        virtual_views: '',
        article_sort: '',
        article_status: '',
        is_delete: '',
      },
      category: [],
      /*验证规则*/
      formRules: {},
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
    };
  },
  props: ['is_open', 'ids'],
  created() {
    this.dialogVisible = this.is_open;
    this.formData.ids = this.ids;
    this.getCategoryList();
  },
  methods: {
    /*获取文章列表*/
    getCategoryList() {
      let self = this;
      let Params = {};
      ArticleApi.getCategory(Params, true).then(data =>{
          self.loading = false;
          self.category = data.data.category;
        })
        .catch(error =>{});
    },
    /*添加*/
    onSubmit() {
      let self = this;
      let params = this.formData;
      if (params.ids.length<=0){
        self.$message({
          message: '暂无选中记录',
          type: 'warning'
        });
        return;
      }
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          ArticleApi.articleBatch(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success'
                });
                self.dialogFormVisible(true);
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/service/service/batch.vue